import {registerPushManager} from "../../webpush/webpush";

export const reducer = (state, action) => {
    switch (action.type) {
        case "logout":
            localStorage.removeItem("token")
            return {
                ...state,
                auth: false,
            }

        case "login":
            localStorage.setItem("token", action.payload.token)
            registerPushManager()
            return {
                ...state,
                auth: true,
                username: action.payload.username,
                preferences: Object.assign(initialState.preferences, action.payload.preferences)
            }
        case "change_username":
            return {
                ...state,
                username: action.payload.username
            }

        case "change_preferences":
            return {
                ...state,
                preferences: action.payload.preferences
            }

        default:
            return state
    }
}

export const initialState = {
    auth: !!localStorage.getItem("token"),
    username: "",
    preferences: {
        notification: true,
    }
}